import type { SearchVehicle } from '../types'

export const account = ({ consignor, consignorLegacyId }: SearchVehicle): string =>
    consignor && consignorLegacyId
        ? `${consignor.toUpperCase()} (${consignorLegacyId})`
        : consignor?.toUpperCase() || 'No data available'
